import { plural, t } from '@lingui/core/macro';
import { Box, Button, IconButton, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function SelectedProjects(props) {
    const { selected, onDeselect } = props;
    const count = selected.length;
    const label = t({
        comment: 'Project picker - selected projects button',
        message: plural(count, {
            0: 'No projects selected',
            one: '# selected project',
            other: '# selected projects',
        }),
    });
    return (<Menu.Root target={<Button type="button" size="small" appearance="ghost" disabled={!count}>
          {label}
        </Button>}>
      <Menu.Header title={t({ comment: 'Project picker - selected projects menu header', message: 'Selected projects' })}/>
      {selected.map((project) => (<Menu.Item key={project.id}>
          {project.name}
          <Box ml="auto">
            <IconButton size="xs" appearance="ghost" aria-label={t({ comment: 'Project picker - deselect project', message: 'Remove' })} onClick={() => onDeselect(project)}>
              <Falcon icon="xmark"/>
            </IconButton>
          </Box>
        </Menu.Item>))}
    </Menu.Root>);
}
